module.exports = __webpack_public_path__ + "img/xianwan2.7e75045c.png";